import React, { useEffect, useState } from "react";
import {
	Dialog,
	DialogContent,
	Typography,
	TextField,
	Button,
	Box,
	IconButton,
} from "@mui/material";
import RegistrationForm from '../Authentication/RegistrationForm';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
	mobialLogin
} from "../../../services/operations/userOperations";
import CustomAlert from "../../common/CustomAlert";
import OTPScreen from "./OTPScreen";
import Loader from "../../common/Loader";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
const LoginOtpModal = ({ open, onClose }) => {
	let userToken = sessionStorage.getItem("token");
	let userType = sessionStorage.getItem("userType")
	let action = sessionStorage.getItem("action")
	let customerId = sessionStorage.getItem("customerId")
	const navigate = useNavigate();
	const [mobileNumber, setMobileNumber] = useState("");
	const [showOTP, setShowOTP] = useState(false);
	const [showRegister, setShowRegister] = useState(false);

	const [
		loading, setLoading] = useState(false);
	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [error, setError] = useState("");

	const dialogStyles = {
		borderRadius: "12px",
		width: { xs: "90%", sm: "388px" },
		height: "auto",
		margin: 0,
		boxShadow: "none",
		maxHeight: "none",
		"& .MuiDialog-paper": {
			margin: 0,
			maxHeight: "none",
			overflowY: "visible",
		},
	};

	const contentStyles = {
		padding: { xs: "24px 16px", sm: "20px" },
		backgroundColor: "white",
		height: "auto",
		display: "flex",
		flexDirection: "column",
		gap: { xs: 2, sm: 3 },
		overflow: "visible",
		position: "relative",
		paddingTop: "50px",
	};

	const buttonStyles = {
		height: { xs: "42px", sm: "48px" },
		backgroundColor: "#C1721F",
		// "#c87629"
		color: "white",
		textTransform: "none",
		fontWeight: 600,
		fontSize: { xs: "16px", sm: "18px" },
		padding: { xs: "10px", sm: "14px" },
		borderRadius: "8px",
		"&:hover": {
			backgroundColor: "rgba(204, 185, 16, 0.5) ",
			color: "black"
		},
	};

	const validateMobileNumber = (number) => {
		if (!number) {
			return "Mobile number is required";
		}
		if (!/^[0-9]{10}$/.test(number)) {
			return "Enter valid 10-digit mobile number";
		}
		return "";
	};

	const handleMobileChange = (e) => {
		const value = e.target.value;
		setMobileNumber(value);
		setError(validateMobileNumber(value));
	};

	const handleSubmit = async () => {
		const validationError = validateMobileNumber(mobileNumber);
		if (validationError) {
			setAlert({
				open: true,
				message: validationError,
				severity: "error",
			});
			return;
		}

		setLoading(true);
		try {
			const response = await mobialLogin(mobileNumber);

			if (!response.status) {
				setAlert({
					open: true,
					message: response.message,
					severity: "error",
				});
				return;
			}

			setShowOTP(true);
			setAlert({
				open: true,
				message: "OTP sent successfully!",
				severity: "success",
			});
		} catch (err) {
			setAlert({
				open: true,
				message: err.message || "Failed to send OTP",
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(()=>{
		if(userToken && userType){
			if(action == "edit"){
				window.location.href = "/profile/personal-details";

			}else{
				// window.location.href = "/profile/Profileroutes";
				navigate(`/profile/ProfileView`, {
					state: { profileId: customerId },
				  })
			}
		}
		

	},[])
	const handleOTPVerified = (token) => {
		localStorage.setItem("token", token);
		onClose();
		window.location.href = "/profile/personal-details";
	};

	const handleBack = () => {
		setShowOTP(false);
	};

	return (
		<>
			<Dialog
				open={open}
				onClose={onClose}
				PaperProps={{
					sx: dialogStyles,
				}}
			>
				<IconButton
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: "#666",
						zIndex: 1,
					}}
				>
					<CloseIcon />
				</IconButton>


				<DialogContent sx={contentStyles}>
					{loading ? (
						<Loader />
					) : showOTP ? (
						<OTPScreen
							phoneNumber={mobileNumber}
							onSubmit={handleOTPVerified}
							onBack={handleBack}
							isLoginOTP={true}
						/>
					) : showRegister ? (
						<Box>
							<IconButton onClick={() => setShowRegister(false)}>
								<ArrowBackIcon />
							</IconButton>
							<Box>
								<RegistrationForm />
							</Box>
						</Box>

					) : (
						<>
							<Typography variant="h5" component="h2" sx={{
								fontFamily: "Roboto",
								fontWeight: 600,
								fontSize: { xs: "16px", sm: "18px" },
								lineHeight: "100%",
								letterSpacing: "0%",

								marginTop: "15px",
							}}>
								Login via OTP
							</Typography>

							<TextField
								fullWidth
								label="Mobile Number"
								variant="outlined"
								value={mobileNumber}
								onChange={handleMobileChange}
								error={!!error}
								helperText={error}
								sx={{
									"& .MuiOutlinedInput-root": {
										height: { xs: "42px", sm: "48px" },
										"&:hover .MuiOutlinedInput-notchedOutline": {
											borderColor: "#c87629",
										},
										"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
											borderColor: "#c87629",
										},
									},
									"& .MuiInputLabel-root": {
										"&.Mui-focused": {
											color: "#c87629",
										},
										transform: "translate(14px, -10px) scale(0.75)",
										"&.MuiInputLabel-shrink": {
											transform: "translate(14px, -8px) scale(0.75)",
										},
									},
									"& .MuiInputLabel-outlined": {
										transform: "translate(14px, 12px) scale(1)",
									},
								}}
							/>

							<Button
								fullWidth
								variant="contained"
								onClick={handleSubmit}
								disabled={loading}
								sx={buttonStyles}
							>
								{loading ? "Sending..." : "Generate OTP"}
							</Button>

							<span style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								padding: "10px",
								fontFamily: '"SF Pro Display", sans-serif',
								fontWeight: 600,
								fontSize: { xs: "15px", sm: "18px", md: "16px" },
							}}>
								Don't have an account?&nbsp;
								<span
									onClick={() => setShowRegister(true)}
									style={{ cursor: "pointer", color: "#C1721F", textDecoration: "underline",   fontFamily: '"SF Pro Display", sans-serif',
										fontWeight: 600,
										fontSize: { xs: "15px", sm: "18px", md: "16px" }, }}
								>
									Sign up Now
								</span>
							</span>
						</>
					)}
				</DialogContent>
				<CustomAlert
					open={alert.open}
					message={alert.message}
					severity={alert.severity}
					onClose={() => setAlert({ ...alert, open: false })}
				/>
			</Dialog>
		</>
	);
};

export default LoginOtpModal;
